import React from 'react'
import { Modal } from 'react-bootstrap'
import { ContentViewUI } from '../../../../widgets/components/ContentViewUI'
import { RecordKeeperContentView } from '../../../../recordskeeper-ai/components/RecordsAndFiles/RecordKeeperContentView'
import Skeleton from 'react-loading-skeleton'

const ViewDocModal = ({
  isActive,
  setIsActive,
  fileName,
  isRecordKeeper,
  viewableData,
  isLoading,
}: any) => {
  console.log(viewableData);

  return (
    <>
      <Modal
        show={isActive}
        onHide={() => {
          setIsActive(false)
        }}
        size='lg'
        fullscreen
      >
        <Modal.Header closeButton>
          <h2>{isRecordKeeper ? fileName : fileName.split('/').pop()}</h2>
        </Modal.Header>
        <Modal.Body className='p-0'>
          <div className='w-100  h-100'>
            {isRecordKeeper ? (
              <>
                {isLoading ? (
                  <Skeleton width='100vw' height='100vh' className='m-5' />
                ) : (
                  <RecordKeeperContentView
                    signURL={viewableData?.downloadUrl}
                    fileName={viewableData?.fileName}
                    extension={viewableData && viewableData?.fileType ? viewableData?.fileType : viewableData && viewableData?.fileName ? viewableData.fileName?.split('.').pop() : ''}
                    customClassNames='w-100 h-100'
                  />
                )}
              </>
            ) : (
              <ContentViewUI fileName={fileName} cssStyle={true} customClassNames='w-100 h-100' />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ViewDocModal
